export default __webpack_public_path__ + "static/media/shadow-type-1.2598f060.svg";